import React, { useState, useEffect, useRef } from 'react';
import styled  from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { breakpoints } from '@/layouts/breakpoints'

import Tower from '@/components/landing/home/tower/Tower';

const StyledComp = styled.div`
  width: 100vw;
  height: calc(100vh - 52px);
  overflow: hidden;
  padding: 0;
  position: relative;
  border-bottom: 1px solid rgba(var(--greyr), 0.3);
  min-height: 600px;

   .graphic{
    overflow: hidden;
    top: 0;
    left: 0;
    z-index: 1;
    opacity: 0.3;
    position: absolute;
    transition: opacity 0s;

    &.fade-in{
      transition: opacity 0.5s ease;
    }

    @media (max-width: 1390px) {
      left: -10vw;
    }

    @media (max-width: 968px) {
      left: 40vw;
      opacity: 0.1;
      width:100vw;
    }
  }

  .text{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    z-index: 2;
    height: auto;
    width: 40vw;
    right: 5%;
    padding: 40px;
    padding-top: 80px;
    flex-direction: column;
    color: var(--black);

    @media (max-width: 1580px) {
      width: 30vw;
      padding-left: 0;
      h1{
        font-size: 3.5rem;
        width: 120%;
      }

    }

    @media (max-width: 1390px) {
      width: 35vw;
     }

    @media (max-width: 1140px) {
      h1{

        font-size: 3.5rem;
      }

    }

    @media (max-height: 700px) {
      h1{
        font-size: 3rem;
      }
    }
    @media (max-width: 968px) {
      width: 100%;
      right: unset;
      padding-top: 120px;
      padding-left: 0;
      padding-right: 0;
      width: 80%;
      left: 10%;
    }

    @media (max-width: ${breakpoints.small}) {
      h1{
        font-size: 2.5rem;
      }
    }

    @media (max-width: 420px) {
      h1{
        width: 90%;
      }
    }
    .actions{
      display: flex;
      flex-direction: row;
      gap: 16px;
      padding-bottom: 48px;
      flex-wrap: wrap;
    }
    button{
      font-size: 16px;
      border: none;
      background-color: var(--black);
      color: var(--white);
      padding: 12px 20px;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      align-items: center;
      transition-duration: 0.3s;
      &:hover{
        background-color: #333;
      }

      &.secondary{
        background-color: transparent;
        color: var(--black);
        svg{
          padding-left: 10px;
          transition-duration: 0.3s;
        }
        &:hover{
          svg{
            transform: translateX(2px);
          }
          background-color: #eee;
        }

      }
    }

    span{
      color: var(--grey);
      // max-width: 500px;
      padding-bottom: 12px;
      font-weight: 100;
      line-height: 1.5;
      font-size: 18px;
      padding: 80px 0;

      @media (max-width: 1600px) {
        padding: 40px 0;
      }
      @media (max-width: ${breakpoints.medium}) {
        font-size: 16px;
        text-align: left;
        max-width: 90%;
      }

      @media (max-width: ${breakpoints.small}) {
        padding-top: 40px;
      }
    }
}

`;

const Fold = ({isVisible}) => {
  const navigate = useNavigate()
  const [shouldRender, setShouldRender] = useState(isVisible);
  const [opacity, setOpacity] = useState(isVisible ? 0.3 : 0);
  const graphicRef = useRef(null);
  const timeoutRef = useRef(null);

  const getTargetOpacity = () => window.innerWidth <= 968 ? 0.1 : 0.3;

  useEffect(() => {
    const el = graphicRef.current;
    if (!isVisible) {
      if (el) el.classList.remove('fade-in');
      setOpacity(0);
      timeoutRef.current = setTimeout(() => {
        setShouldRender(false);
      }, 150);
    } else {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      if (el) el.classList.add('fade-in');
      setOpacity(getTargetOpacity());
      setShouldRender(true);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [isVisible]);

  return (
    <StyledComp>
      <div className="graphic fade-in" style={{ opacity }}>
      {shouldRender && <Tower />}
      </div>

      <div className="text">

        <h1 className="serif">
          Financial Data API<br/>
          for the Modern Market
        </h1>

        <span>
          A unified API for market prices, fundamentals, disclosures, macroeconomic, and alternative data. Designed for long-horizon research and quantitative modeling.
        </span>

        <div>
          <div className="actions">
            <button className="primary" onClick={ () => { navigate('/dashboard/api-keys') } }>Create an API Key  </button>
            <button className="secondary" onClick={ () => { navigate('/docs') } }>View our API docs <ArrowRight size={16} /> </button>
          </div>

        </div>
      </div>
    </StyledComp>
  );
};

export default Fold;
